'use strict';

import React from 'react';
import {h, Fragment} from 'preact';

/**
 * @param price
 * @returns {string | number}
 */
export function discount(price) {
    const discount = global.config.partnershipDiscount;

    price -= (price / 100) * discount;

    if (price > 100) {
        price = Math.round(price);
    } else {
        price = Number(price).toFixed(2);
    }

    return price;
}
